<template>
  <div>
    <div class="daiban">
      <el-row :gutter="20">
        <!-- 左边部分 -->
        <el-col>
          <!-- 用户信息表格 -->
          <el-card class="box-card">
            <div class="right">
              <span style="font-size: 16px">
                <i style="
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    position: relative;
                    top: 3px;
                  ">
                  <img style="width: 100%; height: 100%" src="@/assets/list.png" alt="" />
                </i>
                {{ $t('message.title.releaseFlow') }}
              </span>
              <div class="workFlowView">
                <!-- <div style="overflow: hidden;" > -->
                <div class="workFlowView-bg">
                  <img src="@assets/changeWorkflow/bg.png" alt="">
                </div>
                <el-steps :active="process_Num" class="workFlowView-steps" align-center finish-status="success">
                  <el-step v-for="status in statusInfoShow" :key="status.id" :title="status.name">
                  </el-step>
                </el-steps>
              </div>
              <div>
                <div style="padding: 4px">
                  <p>&nbsp;</p>
                </div>
                <span style="font-size: 16px">
                  <i style="
                      display: inline-block;
                      width: 18px;
                      height: 18px;
                      position: relative;
                      top: 3px;
                    ">
                    <img style="width: 100%; height: 100%" src="@/assets/histroy.png" alt="" />
                  </i>
                  {{ $t('message.title.workflow') }}
                </span>

                <div style="margin-top: 10px">
                  <!-- <el-button
                    :disabled="!addBtnPriv || !noWorkFlow"
                    @click="enableAddSignoffWindow"
                    >{{$t('message.title.editAP_OB')}}</el-button
                  > -->

                  <el-dialog v-dialogDrag v-if="outerVisible" :title="$t('message.title.editAP_OB')"
                    :visible.sync="outerVisible">
                    <el-dialog width="50%" v-dialogDrag :title="$t('message.title.searchUser')"
                      v-if="searchApproverVisible" :visible.sync="searchApproverVisible" append-to-body>
                      <searchAddUsers :userGroupLists1="userGroupLists"
                        :projectWorkflowSubClassId="projectWorkflowSubClassId" @listDbClick="addApprover">
                      </searchAddUsers>
                    </el-dialog>

                    <el-dialog width="50%" v-dialogDrag :title="$t('message.title.searchUser')"
                      v-if="searchObserverVisible" :visible.sync="searchObserverVisible" append-to-body>
                      <searchAddUsers :userGroupLists1="userGroupLists"
                        :projectWorkflowSubClassId="projectWorkflowSubClassId" @listDbClick="addObserver">
                      </searchAddUsers>
                    </el-dialog>

                    <!-- <div slot="footer" class="dialog-footer"> -->
                    <div style="height: 400px; position: relative">
                      <div class="table-list2">
                        <span class="list-key">{{ $t('message.title.addForStatus') }} :</span>

                        <span class="list-val">
                          <el-select v-model="selectedStatus" :placeholder="$t('message.placeholder.select')"
                            size="small" :style="input_width" @change="selectStatus">
                            <el-option v-for="item in statusInfoSignoff" :key="item.id" :label="item.name"
                              :value="item.name">
                            </el-option>
                          </el-select>
                        </span>
                      </div>

                      <div class="table-list2">
                        <span class="list-key">{{ $t('message.title.approver') }} : </span>

                        <span class="list-val" style="float: left">
                          <el-select :style="input_width" size="small" v-model="approvers" multiple filterable remote
                            :placeholder="$t('message.placeholder.input')" :remote-method="remoteMethod"
                            :loading="loading" @change="change">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                              :disabled="item.disabled">
                            </el-option>
                          </el-select>
                        </span>

                        <el-button type="primary" style="float: left" size="small" @click="openSearchApproverWindow">{{
                          $t("message.button.search") }}</el-button>
                      </div>

                      <div class="table-list2">
                        <span class="list-key">{{ $t('message.title.observer') }} : </span>

                        <span class="list-val" style="float: left">
                          <el-select :style="input_width" size="small" v-model="observers" multiple filterable remote
                            :placeholder="$t('message.placeholder.input')" :remote-method="remoteMethod2"
                            :loading="loading" @change="change2">
                            <el-option v-for="item in options2" :key="item.value" :label="item.label"
                              :value="item.value" :disabled="item.disabled">
                            </el-option>
                          </el-select>
                        </span>

                        <el-button type="primary" style="float: left" size="small"
                          @click="searchObserverVisible = true">{{ $t("message.button.search") }}</el-button>
                      </div>

                      <div class="table-list2">
                        <span class="list-key">{{ $t("message.title.annotation") }} : </span>

                        <span class="list-val" style="float: left">
                          <el-input :style="input_width" :autosize="{ minRows: 4, maxRows: 6 }" type="textarea"
                            :rows="2" :placeholder="$t('message.placeholder.input')" v-model="textarea1">
                          </el-input>
                        </span>
                      </div>

                      <div class="table-list2 tableBtn">
                        <el-button @click="updateSignoff(1)" size='small'>{{ $t("message.button.save") }}</el-button>
                        <el-button @click="outerVisible = false" size='small'>{{
                          $t("message.button.cancel")
                          }}</el-button>
                      </div>
                    </div>
                  </el-dialog>


                </div>
              </div>

              <div style="margin-top: 10px">

                <vxe-grid ref="xGridReleasedChange" v-bind="gridOptions" :toolbar-config="tableToolbar"
                  :print-config="{}" :cell-style="{ padding: '3px', 'font-size': '12px', 'line-height': '16px ' }">
                  <template #toolbar_buttons>
                    <el-button :disabled="!addBtnPriv || !noWorkFlow" @click="enableAddSignoffWindow">{{
                      $t('message.title.editAP_OB') }}</el-button>
                    <el-button @click="exportWorkflowHistory" style="margin-left: 10px">{{
                      $t("message.button.export")
                      }}</el-button>
                  </template>
                  <template #img1_default="{ row }">
                    <div style="width: 20px; height: 20px; overflow: hidden">
                      <img v-if="row[0] == '0'" src="@/assets/changeWorkflow/current.png"
                        style="width: 20px; height: 20px" />
                      <img v-if="row[0] == '1'" src="@/assets/changeWorkflow/future.png"
                        style="width: 20px; height: 20px" />
                      <img v-if="row[0] == '2'" src="@/assets/changeWorkflow/forward.png"
                        style="width: 20px; height: 20px" />
                      <img v-if="row[0] == '3'" src="@/assets/changeWorkflow/backward.png"
                        style="width: 20px; height: 20px" />
                      <img v-if="row[0] == '4'" src="@/assets/changeWorkflow/skipped.png"
                        style="width: 20px; height: 20px" />
                      <img v-if="row[0] == '5'" src="@/assets/changeWorkflow/hidden.png"
                        style="width: 20px; height: 20px" />
                    </div>
                  </template>
                </vxe-grid>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style>
.el-input.el-input--medium.el-input--suffix .el-input__inner[style="height: 36px;"] {
  height: 34px !important;
}

.addSignoff .el-radio__label {
  font-size: 16px !important;
}

.workFlowView .el-step__title.is-success {
  color: #fff;
}

.workFlowView .el-step__head.is-success {
  color: #4c93ff;
  border-color: #fff;
}
</style>

<style scoped>
.workFlowView {
  overflow: hidden;
  margin-top: 20px;
  border-radius: 6px;
  background-image: linear-gradient(to right, #3ea4f9, #4588f9);
  position: relative;
}

.workFlowView-steps {
  margin-top: 40px;
  padding-bottom: 30px;
}

.workFlowView-bg {
  width: 80px;
  height: 120px;
  position: absolute;
  right: 0;
  top: 0;
}

.workFlowView-bg img {
  width: 100%;
  height: 100%;
}

.tableBtn {
  position: absolute;
  bottom: 0;
  right: 0;
}

.table-list2 {
  overflow: auto;
  margin-top: 4px;
}

.table-list2 .list-key {
  display: inline-block;
  width: 32%;
  text-align: right;
  font-size: 14px;
  line-height: 40px;
  float: left;
  margin-right: 6px;
}

.table-list2 .list-val {
  display: inline-block;
  width: 40%;
  overflow: hidden;
}
</style>

<script>
import searchAddUsers from "@/components/searchAddUsers.vue"; //引进addUsers window
import axios from "axios";
import XLSX from "xlsx";
import FileSaver from "file-saver";

import { dialogDrag } from '@/utils/directive'
import Vue from "vue";

Vue.directive('dialogDrag', dialogDrag);

export default {
  data() {
    return {
      userGroupLists: "",
      //selectListClickVal:"",
      //isUserGroupAllVal:"2",
      //isUserGroupAll: false,
      tableToolbar: {
        zoom: true,
        print: false, //
        custom: true, // 是否显示自定义列设置按钮
        slots: {
          buttons: 'toolbar_buttons'
        }
      },
      new_Status: "",
      input_width: {
        width: "96%",
      },
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "400",
        size: "small",
        data: [],
        sortConfig: {
          trigger: "cell",
        },

        // print-config: {},
        // export-config: {},
      },

      // tableExport: {
      //     // 默认选中类型
      //     type: 'pdf',
      //     // 自定义类型
      //     types: ['pdf', 'csv', 'html', 'xml', 'txt']
      // },
      process_Num: 0,
      statusInfoSignoff: [],
      statusInfoShow: [],
      statusInfoAll: [],
      outerVisible: false,
      searchApproverVisible: false,
      searchObserverVisible: false,
      addSignoffStatuses: [
        {
          value: "1",
          label: "ccb",
        },
        {
          value: "2",
          label: "release",
        },
      ],
      selectedStatus: "",
      currentStatusType: "",
      options: [],
      options2: [],
      approvers: [],
      observers: [],
      list: [],
      loading: false,
      textarea1: "",
      textarea2: "",

      addBtnPriv: false,
      noWorkFlow: false,
      projectWorkflowSubClassId: "",
    };
  },
  mounted() { },
  components: {
    searchAddUsers,
  },
  methods: {
    change() {
      this.options = [];
    },
    change2() {
      this.options2 = [];
    },

    exportWorkflowHistory() {
      // 对数据预处理
      let data = this.getExportData(true);
      // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: true,
      });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([this.toBuffer(wbout)], {
        type: "application/octet-stream",
      });
      // 保存导出
      FileSaver.saveAs(blob, this.$t('message.title.workflowExport'));
    },
    getExportData(isHead) {
      let datas = this.deepClone(this.gridOptions.data);
      console.log(datas);
      for (let i = 0; i < datas.length; i++) {
        if (datas[i][0] == "") {
          datas[i][0] = ""
        } else if (datas[i][0] == 0) {
          datas[i][0] = "正在执行"
        } else if (datas[i][0] == 1) {
          datas[i][0] = "等待中"
        } else if (datas[i][0] == 2) {
          datas[i][0] = "正常变更"
        } else if (datas[i][0] == 3) {
          datas[i][0] = "变更驳回"
        };
      };
      let columns = this.gridOptions.columns;
      let headers = isHead ? [columns.map((item) => item.title)] : [];
      return headers.concat(
        datas.map((row) => {
          return columns.map((column) => {
            return row[column.field];
          });
        })
      );
    },
    toBuffer(wbout) {
      let buf = new ArrayBuffer(wbout.length);
      let view = new Uint8Array(buf);
      for (let index = 0; index !== wbout.length; ++index)
        view[index] = wbout.charCodeAt(index) & 0xff;
      return buf;
    },

    openSearchApproverWindow() {
      //console.log(this.approvers);
      this.searchApproverVisible = true;
    },
    addApprover(row) {
      //添加
      if (row) {
        // console.log(this.approvers.length);
        //console.log(row);
        var isDuplicateVal = false;
        for (var j = 0; j < this.approvers.length; j++) {
          //console.log(this.approvers[j]);
          if (row.itemId == this.approvers[j]) {
            isDuplicateVal = true;
            break;
          }
        }
        if (isDuplicateVal) {
          this.$message.error(this.$t('message.error.sameUser'));
        } else {
          // this.searchApproverVisible = false;
          let user = {};
          user.value = row.itemId;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].value == row.itemId) {
              user.label = this.list[i].label;
            }
          }
          this.options.push(user);
          this.approvers.push(row.itemId);
          this.$message.success('添加成功')
        }
      }
    },
    addObserver(row) {
      //添加
      if (row) {
        console.log(this.observers.length);
        //console.log(row);
        var isDuplicateVal = false;
        for (var j = 0; j < this.observers.length; j++) {
          if (row.itemId == this.observers[j]) {
            isDuplicateVal = true;
            break;
          }
        }
        if (isDuplicateVal) {
          this.$message.error(this.$t('message.error.sameUser'));
        } else {
          // this.searchObserverVisible = false;
          let user = {};
          user.value = row.itemId;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].value == row.itemId) {
              user.label = this.list[i].label;
            }
          }
          this.options2.push(user);
          this.observers.push(row.itemId);
          this.$message.success('添加成功')
        }
      }
    },
    async loadStatusForObserver(val) {
      var value_ = "";
      if (val) {
        value_ = val;
      } else {
        value_ = this.$route.query.currentStatusId;
      }
      if (value_ === "" || value_ == 0) value_ = -1;
      var getAllStatus = {
        statusId: value_,
      };
      const getAllStatusUrl = `/pmdm/admin/workflow/getStatusForObserver${this.params(
        getAllStatus
      )}`;
      const { data: res } = await this.$http.get(getAllStatusUrl);
      console.log(res);
      if (res.code == 200) {
        this.statusInfoSignoff = res.object;
      }

      if (value_ > 0) {
        this.noWorkFlow = true;
      } else {
        this.noWorkFlow = false;
      }
    },
    selectStatus() {
      var getSignoffByStatus = {
        changeId: this.$route.query.id,
        statusId: this.getStatusIdByName(this.selectedStatus),
      };
      this.getSignoffUserAPI(getSignoffByStatus).then(res => {
        const SignoffUser = res.data.object;
        this.setSignoffUser(SignoffUser);
      })

    },
    getSignoffUserAPI(obj) {
      return axios.get(`/pmdm/admin/workflow/querySignoffByStatus${this.params(obj)}`)
    },
    async loadStatusInfoShow(val) {
      console.log(val);
      var value_ = "";
      if (val) {
        value_ = val;
      } else {
        value_ = this.$route.query.currentStatusId;
      }
      if (value_ === "" || value_ === 0) value_ = -1;
      //console.log(value_);
      this.statusInfoShow = [];
      var workflowId = this.$route.query.workflowId;
      if (workflowId === "" || workflowId === 0) workflowId = -1;
      var obj_get = {
        //获取change
        statusId: value_,
        workflowId: workflowId,
        id: this.$route.query.id,
      };
      // console.log(obj_get);
      var loadTableUrl = `/pmdm/admin/workflow/getStatusWithoutHoldCancel${this.params(
        obj_get
      )}`;
      const {
        //获取标题
        data: res,
      } = await this.$http.get(loadTableUrl);
      //console.log(res);
      if (res.code == 200) {
        this.statusInfoShow = res.object;
        this.statusInfoAll = res.object;
        //console.log(this.statusInfoAll);
        this.process_Num = value_;
        console.log(this.process_Num);
      }
      for (var i = 0; i < this.statusInfoAll.length; i++) {
        if (this.statusInfoAll[i].id == value_) {
          this.currentStatusType = this.statusInfoAll[i].statusType;
          this.process_Num = i;
        }
      };
      this.$route.query.currentStatusId = val;
    },
    async loadWorkflowHistory() {
      var obj_get = {
        //获取change
        ...this.$store.state.objectId
        // id: this.$route.query.id,
        // classId: this.$route.query.classId,
        // subClassId: this.$route.query.subClassId,
      };
      var loadTableUrl = `/pmdm/changes/loadWorkflowTable${this.params(obj_get)}`;
      const {
        //获取标题
        data: res,
      } = await this.$http.get(loadTableUrl);
      this.gridOptions.columns = this.getNewTableTitleData(res);
      var img_model = { default: "img1_default" };
      this.gridOptions.columns[1].slots = img_model;
      this.gridOptions.columns[1].width = 80;

      this.rols_text = this.getNewTableContentData(res);
      //this.gridOptions.data = this.rols_text;
      //console.log(this.gridOptions.columns);
      this.gridOptions.data = this.rols_text;
      console.log(this.rols_text);
    },

    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethod2(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options2 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options2 = [];
      }
    },
    getUserLoginId(userId) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].value == userId) {
          return this.list[i].label;
        }
      }
    },
    getUserId(loginId) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].label == loginId) {
          return this.list[i].value;
        }
      }
    },
    getStatusIdByName(statusName) {
      for (var i = 0; i < this.statusInfoAll.length; i++) {
        if (this.statusInfoAll[i].name == statusName) {
          return this.statusInfoAll[i].id;
        }
      }
    },
    reOrganizeSignoffUser(signoffUsers) {
      let tempUsers = [];
      for (var i = 0; i < signoffUsers.length; i++) {
        if (this.getUserLoginId(signoffUsers[i]) == undefined) {
          tempUsers.push(this.getUserId(signoffUsers[i]));
        } else {
          //console.log(signoffUsers[i]);
          tempUsers.push(signoffUsers[i]);
        }
      }
      //console.log(tempApprovers);
      return tempUsers;
    },
    updateSignoff(val) {
      let textarea_val = "";
      if (this.selectedStatus == "") {
        return false;
      }
      if (val == 1) {
        textarea_val = this.textarea1;
      } else {
        textarea_val = this.textarea2;
      }

      var approversInRequest = [];
      for (var i = 0; i < this.approvers.length; i++) {
        let user = {};
        user.id = this.approvers[i];
        for (var j = 0; j < this.list.length; j++) {
          if (this.approvers[i] == this.list[j].value) {
            user.loginId = this.list[j].label.replace(/\([^\)]*\)/g, "");
          }
        }
        //user.loginId = this.getUserLoginId(tempApprovers[i]);
        user.type = "1";
        approversInRequest.push(user);
      }

      var observersInRequest = [];
      for (var i = 0; i < this.observers.length; i++) {
        let user = {};
        user.id = this.observers[i];
        for (var j = 0; j < this.list.length; j++) {
          if (this.observers[i] == this.list[j].value) {
            user.loginId = this.list[j].label.replace(/\([^\)]*\)/g, "");
          }
        }
        user.type = "2";
        observersInRequest.push(user);
      }

      for (var m = 0; m < approversInRequest.length; m++) {
        for (var n = 0; n < observersInRequest.length; n++) {
          if (approversInRequest[m].id == observersInRequest[n].id) {
            this.$message.error(this.MessageInfo.e_203);
            return false;
          }
        }
      }
      console.log(approversInRequest);
      console.log(observersInRequest);

      var updateSignoffRequest = {
        //post更改的值
        objectId: {
          ...this.$store.state.objectId
          // id: this.$route.query.id,
          // classId: this.$route.query.classId,
          // subClassId: this.$route.query.subClassId,
          // version:this.version
        },
        status: this.getStatusIdByName(this.selectedStatus),
        approvers: approversInRequest,
        observers: observersInRequest,
        comments: textarea_val,
      };
      //console.log(updateSignoffRequest);
      var vm = this;
      axios
        .post("/pmdm/changes/updateChangeSignoff", updateSignoffRequest)
        .then(function (res) {
          if (res.data.code == 200) {
            vm.loadWorkflowHistory();
            vm.outerVisible = false;
            vm.$message({
              message: res.data.message,
              type: "success",
            });
            vm.$parent.logoInfo();
          }
        })
        .catch(function (error) {
          //vm.$message.error(this.$t('message.error.change'));
          console.log(error);
          vm.outerVisible = false;
        });

      // console.log(this.approvers);
      // console.log(this.selectedStatus);
    },
    async updateUsers() {
      const arr = this.getAppData();
      Promise.all(arr).then(res => {
        const [UsersAndUserGroup, SignoffUser] = res.map(i => i.data.object);
        const { userGroups, users } = UsersAndUserGroup;
        this.setUsersAndUserGroup({ users, userGroups });
        this.setSignoffUser(SignoffUser);
      })

    },

    setUsersAndUserGroup({ users, userGroups }) {
      this.list = users.map(i => {
        const { id: value, loginId, userName, authTag } = i;
        return {
          value,
          label: `${loginId}(${userName})`,
          disabled: !Boolean(authTag)
        }
      })
      this.userGroupLists = userGroups.map(i => {
        const { id, name, authTag } = i;
        return {
          id, name,
          disabled: !Boolean(authTag)
        }
      })
    },
    setSignoffUser(data) {
      const { approveUserGroupList, approveUserList, comments, observerUserGroupList, observerUserList } = data;
      this.textarea1 = comments;
      this.options = approveUserList.map(i => ({ value: i.id, label: `${i.loginId}(${i.userName})` }));
      this.approvers = this.options.map(i => i.value);
      this.options2 = observerUserList.map(i => ({ value: i.id, label: `${i.loginId}(${i.userName})` }));
      this.observers = this.options2.map(i => i.value);

    },

    getAppData() {
      this.selectedStatus = this.statusInfoSignoff[0].name;
      var getSignoffByStatus = {
        changeId: this.$route.query.id,
        statusId: this.getStatusIdByName(this.selectedStatus),
      };

      const obj = {
        privType: 16,
        "subclassId": this.$route.query.subClassId
      }
      return [
        axios.get(`/pmdm/admin/user/getApproveUserList${this.params(obj)}`),
        this.getSignoffUserAPI(getSignoffByStatus)
      ]
    },

    enableAddSignoffWindow() {
      this.approvers = [];
      this.observers = [];
      this.selectedStatus = "";
      this.outerVisible = true;
      this.textarea1 = "";
      this.updateUsers();
    },
    loadUserPriv() {
      var priv_ = this.getUserContextPriv();
      // console.log(priv_);
      let subClass_Id = this.$route.query.subClassId;
      console.log(subClass_Id);
      this.projectWorkflowSubClassId = subClass_Id;
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          //console.log(priv_[i]);
          if (priv_[i].type == 0 || priv_[i].type == 19) {
            this.addBtnPriv = true;
            //console.log(priv_[i]);
          }
          if (priv_[i].type == 15) {
            this.tableToolbar.print = true;
            //console.log(priv_[i]);
          }
        }
      };

      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (isSupAdmin) {
        this.addBtnPriv = true;
        this.tableToolbar.print = true;
      };
    },
  },
  created() {

    // console.log(this.$route.params);
    this.loadUserPriv();
    this.loadStatusForObserver();
    this.loadStatusInfoShow();
    this.loadWorkflowHistory();
  },
  props: ["changeValue", "updateWorkflow"],
  watch: {
    changeValue: function (value) {
      this.loadStatusForObserver(value);
      this.loadStatusInfoShow(value);
      this.loadWorkflowHistory();
    },
    updateWorkflow: function (value) {
      //this.get_status_info = value;
      this.loadWorkflowHistory();
    },
  },
};
</script>
